<template>
 <div id="componentId"
 :class="Tooltip" >
 <div v-html="rawHtml"></div>
</div>
</template>


<script>
export default {
  name: "Tooltip",
  props: {
    componentId: '',
    rawHtml: { String, default: "" },
    // text: {String, default: 'No Tooltip'},

    // overrideStyle: {
    //   top: { String, default: "40px" },
    //   left: { String, default: "40px" }
    // },
    
  },
  data() {
    return {
      Tooltip:{},
    };
  },
  created() {},
  methods: {
    rightClick(data) {
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss'>
.Tooltip {
  background-color: #e4e4e3;
  position: fixed;
}

#map-popup-tooltip {
  padding: 5px;
}

.pop-up-atribute {
  margin: 0px;
  margin-bottom: 3px;
  font-size: 12px;
}
</style>
